import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ScheduleFragmentDoc } from './Schedule';
import { UserDataFragmentDoc } from '../../../../../graphql/fragments/generated/UserData';
export type MeetingListItemFragment = { id: string, name?: string | null, type: Types.MeetingTypeEnum, status: Types.PublicMeetingStatusEnum, nextOccurrenceDate: string, lastOccurrenceDate?: string | null, participantsCount?: number | null, templateId?: string | null, schedule: { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null }, participantsProfile: Array<{ id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null }> };


export type MeetingListItemFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const MeetingListItemFragmentDoc = /*#__PURE__*/ gql`
    fragment MeetingListItem on MeetingType {
  id
  name
  type
  status
  nextOccurrenceDate
  lastOccurrenceDate
  participantsCount
  templateId
  schedule {
    ...Schedule
  }
  participantsProfile {
    ...UserData
  }
}
    `;